import { render, staticRenderFns } from "./hnPaper.vue?vue&type=template&id=18e4b9a1&scoped=true&"
import script from "./hnPaper.vue?vue&type=script&lang=js&"
export * from "./hnPaper.vue?vue&type=script&lang=js&"
import style0 from "./hnPaper.vue?vue&type=style&index=0&id=18e4b9a1&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e4b9a1",
  null
  
)

export default component.exports